<template>
  <div class="row">
    <div class="col-12">
      <div class="container-fluid p-3 text-center">
        <img
          src="/static/img/iconos/Riego2trazo-Smartcultivo.svg"
          style="width: 300px; height: 100px"
        />
        <br />
        <span style="font-size: 25px">
          {{ dictionary.text_1 }}
          <span style="color: #005d2c">{{ dictionary.text_2 }}</span>
          {{ dictionary.text_3 }}
        </span>
        <br />
        <span style="font-size: 18px">
          {{ dictionary.text_4 }}
        </span>
        <br />
        <span>
          {{ dictionary.text_5 }}
        </span>
        <br /><br />
        <div class="row" style="justify-content: center">
          <center>
            <div class="col-12" style="display: flex">
              <div class="has-label">
                <fg-input
                  type="email"
                  v-model="model.email"
                  name="email"
                  placeholder="Email"
                  class="required-mail"
                  @keyup="mailValidated"
                  style="width: 300px; margin-right: 5px"
                  maxlength="50"
                ></fg-input>
              </div>
              <div class="text-center">
                <button
                  class="btn btn-secondary custom-shadow-btn"
                  @click="validate"
                  :disabled="band"
                >
                  {{ dictionary.text_6 }}
                  <em class="fa fa-chevron-right"></em>
                </button>
              </div>
            </div>
          </center>
        </div>
        <span style="font-size: 25px; color: #005d2c">{{
          dictionary.text_7
        }}</span>
        <div class="row">
          <div class="col-md">
            <img
              src="/static/img/languageIcons/bandera-de-estados-unidos.png"
              class="form-img-button-traslate-En"
              @click="En()"
              v-tooltip.top-center="'English'"
            />
            <img
              src="/static/img/languageIcons/bandera-de-espana.png"
              class="form-img-button-traslate-Es"
              @click="Es()"
              v-tooltip.top-center="'Español'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinTranslate from 'src/util/mixinTranslate';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinMenu from 'src/util/mixinMenu';
import { Axios } from 'src/class/Axios.js';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      model: {
        email: null,
        language: 'Es',
      },
      globalDictionary: {},
      dictionary: {
        text_1: null,
        text_2: null,
        text_3: null,
        text_4: null,
        text_5: null,
        text_6: null,
        text_7: null,
      },
      modelValidations: {
        mail: {
          required: true,
        },
      },
      band: true,
      msg: null,
    };
  },
  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinExport,
    MixinMenu,
    MixinTranslate,
  ],
  methods: {
    En() {
      this.dictionary = this.translateEn()['form'];
      this.globalDictionary = this.translateEn();
      sessionStorage.setItem(
        'globalDictionary',
        JSON.stringify(this.globalDictionary)
      );
      this.model.language = 'En';
    },
    Es() {
      this.dictionary = this.translateEs()['form'];
      this.globalDictionary = this.translateEs();
      sessionStorage.setItem(
        'globalDictionary',
        JSON.stringify(this.globalDictionary)
      );
      this.model.language = 'Es';
    },
    mailValidated(e) {
      let exp_val =
        /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z]{2,}))$/;
      if (!exp_val.test(e.srcElement.value) && e.srcElement.value * 1 != 0) {
        e.srcElement.classList.add('custom-has-error');
        this.band = true;
      } else {
        e.srcElement.classList.remove('custom-has-error');
        this.band = false;
      }
    },
    validate() {
      if (this.model.email == null || this.model.email.length < 6) return;
      this.showHideLoading(true);
      this.model.route = 'climatenotification/validateEmail';
      Axios.saveMaster(this.model)
        .then((response) => {
          if (response.data.code == 500) {
            SweetAlert.warning(response.data.response);
          } else {
            sessionStorage.setItem('editForm', JSON.stringify(this.model));
            this.$router.push({
              path: 'form/create',
            });
          }
          this.showHideLoading();
          /*this.forceRenderMenu();
           */
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.danger(error.response.data.message);
        });
    },
  },
  created() {
    if (sessionStorage.getItem('globalDictionary')) {
      this.dictionary = JSON.parse(
        sessionStorage.getItem('globalDictionary')
      ).form;
      this.model.language = JSON.parse(
        sessionStorage.getItem('globalDictionary')
      ).language;
    } else {
      this.model.language = 'Es';
      this.Es();
    }
  },
  mounted() {
    this.selectedItemOnMenu('irrigation');
  },
  destroyed() {
    this.deselectedItemOnMenu('irrigation');
  },
};
</script>
<style>
.form-img-button-traslate-Es {
  width: 45px;
  cursor: pointer;
  border-radius: 50px;
}

.form-img-button-traslate-En {
  width: 45px;
  cursor: pointer;
  border-radius: 50px;
}
</style>
